// Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"
vue.use(vuex);

// Store
const fechacorte = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/indicador`,
    state: {
        fechascorte: null
    }
}).get({
    action: "get_fechacorteglobal",
    path: function (obj) {
        return `/fecha/${obj.idperiodo}`;
    }
    ,
    onSuccess: (state, payload) => {
        state.fechascorte = payload.data;
    }
    ,
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).get({
    action: "get_fechacortepunto",
    path: function (obj) {
        return `/fecha/punto/${obj.idpunto}/${obj.idperiodo}`;
    }
    ,
    onSuccess: (state, payload) => {
        state.fechascorte = payload.data;
    }
    ,
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).get({
    action: "get_fechacorteclasificacion",
    path: function (obj) {
        return `/fecha/clasificacion/${obj.idclasificacion}/${obj.idperiodo}`;
    }
    ,
    onSuccess: (state, payload) => {
        state.fechascorte = payload.data;
    }
    ,
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).get({
    action: "get_fechacortesector",
    path: function (obj) {
        return `/fecha/sector/${obj.idsector}/${obj.idperiodo}`;
    }
    ,
    onSuccess: (state, payload) => {
        state.fechascorte = payload.data;
    }
    ,
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).get({
    action: "get_fechacorteentidad",
    path: function (obj) {
        return `/fecha/entidad/${obj.identidad}/${obj.idperiodo}`;
    }
    ,
    onSuccess: (state, payload) => {
        state.fechascorte = payload.data;
    }
    ,
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).getStore();

fechacorte.getters = {
    gfechacorte: state => {
        return state.fechascorte;
    }
}

export default fechacorte;
